import ISerializable from '../../../../lib/ISerializable';

export default class PageGeneratedData implements ISerializable {
  private textAreas: {
    languageCode: string;
    name: string;
    text: string;
  }[] = [];

  private pictureAreas: {
    image: null | {
      ObjectURL: string;
      PresignedUrl: string;
    };
    name: string;
  }[] = [];

  private id: string | number;

  private parent: string | number;

  /**
   * The type of the page
   */
  private type: string;

  private pageName: string;

  /**
   * Path to the page used in preview mode, we open this path in the preview iframe
   */
  private pagePath: string;

  private isCustomPage: boolean;

  private isPageExternal: boolean;

  constructor(data?: {
    textAreas: {
      languageCode: string;
      name: string;
      text: string;
    }[];
    pictureAreas: {
      image: null | {
        ObjectURL: string;
        PresignedUrl: string;
      };
      name: string;
    }[];
    id: string | number;
    parent: string | number;
    type: string;
    pageName: string;
    pagePath: string;
    isCustomPage: boolean;
    isPageExternal: boolean;
  }) {
    if (data) {
      this.id = data.id;
      this.parent = data.parent;
      this.type = data.type;
      this.textAreas = data.textAreas;
      this.pictureAreas = data.pictureAreas;
      this.pageName = data.pageName;
      this.pagePath = data.pagePath;
      this.isCustomPage = data.isCustomPage;
      this.isPageExternal = data.isPageExternal;
    }
  }

  public serialize(): string {
    let data = {
      textAreas: this.textAreas,
      pictureAreas: this.pictureAreas,
      id: this.id,
      parent: this.parent,
      type: this.type,
      pageName: this.pageName,
      pagePath: this.pagePath,
      isCustomPage: this.isCustomPage,
      isPageExternal: this.isPageExternal
    };

    return JSON.stringify(data);
  }

  public deserialize(data: string): void {
    let parsedData = JSON.parse(data);

    this.id = parsedData.id;
    this.parent = parsedData.parent;
    this.type = parsedData.type;
    this.textAreas = parsedData.textAreas;
    this.pictureAreas = parsedData.pictureAreas;
    this.pageName = parsedData.pageName;
    this.pagePath = parsedData.pagePath;
    this.isCustomPage = parsedData.isCustomPage;
    this.isPageExternal = parsedData.isPageExternal;
  }

  public getId() {
    return this.id;
  }

  public getParent() {
    return this.parent;
  }

  public getType() {
    return this.type;
  }

  public getTextAreas() {
    return this.textAreas;
  }

  public getPictureAreas() {
    return this.pictureAreas;
  }

  public getPageName() {
    return this.pageName;
  }

  public getPagePath() {
    let path = '';

    if (this.isCustomPage || this.type === 'dynamic') {
      path = '/__custom';
    } else if (this.isPageExternal) {
      path = '/__external';
    } else {
      path = `/${this.pagePath}`;
    }

    return path;
  }

  public getDataToBeInjectedInThePreview() {
    return {
      pageContent: {
        textAreas: this.textAreas,
        pictureAreas: this.pictureAreas
      }
    };
  }
}
